// extracted by mini-css-extract-plugin
export default {"tableHeaderHint":"tableColumn_tableHeaderHint__J9z3t","bubbles":"tableColumn_bubbles__Vl8cY"};